let timeoutId: number | null = null;

type AnnounceOptions = {
    regionId?: string;
    delayMs?: number;
};

// Schreibt Texte in die aria live region zur Sprachausgabe
// Singleton-Funktion
export const announceForScreenReader = (text: string, options: AnnounceOptions = {}) => {
    const { regionId = "screenreader-status", delayMs = 20 } = options;

    const region = document.getElementById(regionId);
    if (!region) {
        return;
    }

    if (timeoutId !== null) {
        window.clearTimeout(timeoutId);
        timeoutId = null;
    }

    // Reset, da Reader manchmal gleiche oder zu schnelle Änderungen ignorieren
    region.textContent = "";

    // Damit Screenreader immer reagiert
    timeoutId = window.setTimeout(() => {
        region.textContent = text;
        timeoutId = null;
    }, delayMs);
};
